<template>
  <v-card>
    <v-card-text>
      <h3>Time</h3>
      <convert-box></convert-box>
    </v-card-text>
  </v-card>
</template>

<script>
import ConvertBox from '../components/ConvertBox'

export default {
  components: { ConvertBox },
  data() {
    return {
      unit: [
        {
          text: 'Second',
          val: 1
        },
        {
          text: 'Millisecond',
          val: 1000
        },
        {
          text: 'Nanosecond',
          val: 1000000000
        },
        {
          text: 'Picosecond',
          val: 1000000000000
        },
        {
          text: 'Minute',
          val: 1 / 60
        },
        {
          text: 'Hour',
          val: 1 / 3600
        },
        {
          text: 'Day',
          val: 1 / 86400
        },
        {
          text: 'Week',
          val: 1 / 604800
        },
        {
          text: 'Month',
          val: 3.802570537e-7
        },
        {
          text: 'Year',
          val: 3.168808781e-8
        }
      ]
    }
  },
  created() {
    this.$store.dispatch('setUnit', this.unit)
  }
}
</script>

<style>
</style>



// WEBPACK FOOTER //
// time.vue?43dbf868